<script>
import { onMount } from "svelte";
import axios from "axios";
const endpoint = "https://spiele.ulrichlang.de/last_update.php";
let timestamp = [];
let formattedTime = [];
onMount(async function () {
  try {
    const response = await axios.get(endpoint);
    timestamp = response.data;

  if (!timestamp){
    console.log("Problem gefunden");
  } else{
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const date = new Date(timestamp * 1000);
const hours = ("0" + date.getHours()).slice(-2);  
const minutes = "0" + date.getMinutes();
const seconds = "0" + date.getSeconds();
formattedTime = `${hours}:${minutes.substr(-2)}:${seconds.substr(-2)}`;
console.log(formattedTime);
    // console.log(timestamp);

  }
  } catch (error) {
    console.error(error);
  }
});

</script>
<main>
    <div>
<span>Letztes Update um {formattedTime} Uhr</span>
</div>
</main>
<style></style>